import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Table, Image } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinearProgress from "@mui/material/LinearProgress";

const AddNotification = ({ showModal, handleClose, fetchAllNotification }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const initialValues = {
        not_title: "",
        not_message: "",
        created_by: sessionStorage.getItem("pk_user_key"),
        visibility: 1,
    };

    const basicSchema = Yup.object().shape({
        not_title: Yup.string()
            .min(3, "Notification title must be at least 3 characters.")
            .max(100, "Notification title must be at most 100 characters.")
            .matches(/^[^\s].*[^\s]$/, "Notification Title should not have leading or trailing spaces.")
            .required("Notification title is required.")
            .test("unique-link", "Notification title already existing in the database", async function (value) {
                if (!value) return true;
                const isNotificationTitleUnique = await checkNotificationTitle(value);
                return isNotificationTitleUnique;
            }),

        not_message: Yup.string()
            .min(10, "Notification message must be at least 10 characters.")
            .max(500, "Notification message must be at most 500 characters.")
            .matches(/^[^\s].*[^\s]$/, "Notification message should not have leading or trailing spaces.")
            .required("Notification Message is required."),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "addNotification",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                resetFormFields(resetForm, setValues, initialValues);
                handleClose();
                fetchAllNotification();
                toast.success("Added successfully!", {
                    autoClose: 3000,
                });
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    async function checkNotificationTitle(not_title) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkNotificationTitle",
            not_title: not_title,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }
    return (
        <>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Notification</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <Form.Group controlId="formTitle" className="mb-3">
                            <Form.Label>Title <span className="text-danger">*</span> </Form.Label>
                            <Form.Control
                                type="text"
                                name="not_title"
                                placeholder="Enter notification title"
                                value={values.not_title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.not_title && touched.not_title && <p className="text-danger">{errors.not_title}</p>}
                        </Form.Group>
                        <Form.Group controlId="formnot_message">
                            <Form.Label>Message <span className="text-danger">*</span> </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="not_message"
                                placeholder="Enter notification message"
                                value={values.not_message}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.not_message && touched.not_message && <p className="text-danger">{errors.not_message}</p>}
                        </Form.Group>
                        <Button variant="dark" type="submit" className="mt-3" disabled={isSubmitting}>
                            Save
                            {isSubmitting && <LinearProgress />}
                        </Button>
                        <Button variant="outline-secondary" className="ms-2 mt-3" onClick={handleClose}>
                            Cancel
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddNotification;
